<mat-toolbar color="primary" class="toolbar-style">
  <span class="toolbar-header">{{ res.get('ObjectInfoPanel-Title') }}</span>
  <span class="toolbar-spacer"></span>

  <button mat-icon-button class="toolBarButton" (click)="this.frame.lib.closeBottomSheet()">
    <mat-icon [svgIcon]="res.svgName('ExpandMore-Image')"></mat-icon>
  </button>
</mat-toolbar>

<div [ngStyle]="{ overflow: 'scroll', display: activeObjectInfo ? 'block' : 'none' }">
  <app-object-info></app-object-info>
</div>

<div class="noDataPlaceHolder" [ngStyle]="{ display: !activeObjectInfo ? 'block' : 'none' }">
  &lt;{{ res.get('ObjectInfoPanel-NoData') }}&gt;
</div>
